import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";

export const processDirectValue = (
  styleValue: StyleValue,
): string | number | undefined => {
  if (
    typeof styleValue.value === "string" ||
    typeof styleValue.value === "number"
  ) {
    return styleValue.value;
  }

  return undefined;
};
